import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import NotesSectionTable from './NotesSectionTable';
import { useNotesSection } from '../context/NotesSectionContext';

const NotesSectionBody: FC = () => {
  const { data, actions } = useNotesSection();

  const showPagination =
    data.notes && data.notesTotal > (data.rowsPerPage || 10);

  return (
    <div className="mt-4">
      {data.isLoadingNotes ? (
        <TableSkeleton
          rows={10}
          columns={3}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <NotesSectionTable />
      )}

      {showPagination && (
        <DataTablePagination
          className="border-0"
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.notesTotal || 0}
          paginate={actions.handleChangePage}
          currentPage={data.page}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};
export default NotesSectionBody;
